// Importing All Images
import Unveil1 from "../images/Union 33.png";
import Unveil2 from "../images/Union 34.png";
import Unveil3 from "../images/Union 35.png";
import Unveil4 from "../images/Union 36.png";
import Unveil5 from "../images/Union 37.png";
import Unveil6 from "../images/Union 38.png";
import HomeImg from "../images/Leadbud Dashboard.png";
import BeyondImg from "../images/beyondimg.png";

// Exporting Images as an Object
const images = {
    unveil: {
        Unveil1,
        Unveil2,
        Unveil3,
        Unveil4,
        Unveil5,
        Unveil6,
    },
    home: HomeImg,
    beyond: BeyondImg,
};

export default images;
